import {Component, Inject, OnInit} from '@angular/core';
import {BaseCustomDialog} from '../base-custom-dialog';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'fi-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.scss'],
  standalone: false,
})
export class MaintenanceModeComponent extends BaseCustomDialog implements OnInit {

  endDate: string;
  translations: MaintenanceTranslations;
  languageCode: string;

  constructor(
    public dialogRef: MatDialogRef<MaintenanceModeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { endDate: string },
  ) {
    super(dialogRef);
    this.endDate = dialogData?.endDate;
  }

  ngOnInit(): void {
    this.setMaintenanceTranslations();
  }

  setMaintenanceTranslations(): void {
    this.languageCode = window.navigator.language;

    switch (this.languageCode) {
      case 'it' :
        this.translations = {
          title: 'Torniamo presto.',
          description: 'A causa di lavori di manutenzione, Finstral Contacts non è al momento raggiungibile.',
          mailText: 'Per qualsiasi domanda puoi scrivere a',
          epilogueFirst: 'Grazie per la comprensione.',
          epilogueLast: 'Il Team di Finstral Contacts'
        };
        break;
      case 'it-IT' :
        this.translations = {
          title: 'Torniamo presto.',
          description: 'A causa di lavori di manutenzione, Finstral Contacts non è al momento raggiungibile.',
          mailText: 'Per qualsiasi domanda puoi scrivere a',
          epilogueFirst: 'Grazie per la comprensione.',
          epilogueLast: 'Il Team di Finstral Contacts'
        };
        break;
      case 'nl' :
        this.translations = {
          title: 'We zijn snel weer terug.',
          description: 'Wegens onderhoudswerkzaamheden is Finstral Contacts momenteel niet beschikbaar.',
          mailText: 'Indien u vragen heeft, kunt u contact opnemen met',
          epilogueFirst: 'Dank u voor uw begrip.',
          epilogueLast: 'Het Finstral Contacts Team'
        };
        break;
      case 'es' :
        this.translations = {
          title: 'Volvemos pronto.',
          description: 'Debido a trabajos de mantenimiento, Finstral Contacts no está disponible actualmente.',
          mailText: 'Si tiene alguna pregunta, escribanos a',
          epilogueFirst: 'Gracias por su comprensión.',
          epilogueLast: 'Team de Finstral Contacts'
        };
        break;
      default :
        this.translations = {
          title: 'Wir sind bald zurück.',
          description: 'Aufgrund von Wartungsarbeiten ist Finstral Contacts momentan nicht verfügbar.',
          mailText: 'Bei Fragen wende Dich an',
          epilogueFirst: 'Vielen Dank für Dein Verständnis.',
          epilogueLast: 'Das Finstral Contacts Team'
        };
        break;
    }
  }

  onReloadPopup(): void {
    this.clearClassAndCloseDialog(this.dialogRef);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onReloadPopup();
    }
  }
}

export interface MaintenanceTranslations {
  title: string;
  description: string;
  mailText: string;
  epilogueFirst: string;
  epilogueLast: string;
}

